// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { prepareDefaultHeaders } from '../../api'

export enum AIImageType {
  LIVE_EVENT_COMMENT_MONTHLY_RECAP = 'LIVE_EVENT_COMMENT_MONTHLY_RECAP',
}

const REDUCER_PATH = 'internalLiveEventPredictionsApi'

export const internalLiveEventPredictionsApi = createApi({
  reducerPath: REDUCER_PATH,
  baseQuery: fetchBaseQuery({
    baseUrl: window.GR_API_URLS.API_URL_LIVE_EVENTS_PREDICTIONS + '/i/',
    prepareHeaders: prepareDefaultHeaders,
  }),
  endpoints: (builder) => ({
    getLiveEventAISummaryForCustomPrompt: builder.query<
      string,
      { gameId: string; prompt: string; months: number; reasoningLevel: 'low' | 'medium' | 'high'; interpreter: boolean }
    >({
      query: ({ gameId, prompt, months, reasoningLevel, interpreter }) => ({
        url: '/summary/generate/custom',
        method: 'POST',
        responseHandler: 'text',
        body: {
          gameId,
          prompt,
          months,
          reasoningLevel,
          interpreter,
        },
      }),
    }),
    generateAIImage: builder.mutation<{ imageUrl: string }, { type: AIImageType; prompt: string; gameName: string }>({
      query: ({ type, prompt, gameName }) => ({
        url: '/images',
        method: 'POST',
        body: {
          type,
          prompt,
          gameName,
        },
      }),
    }),
  }),
})

export const { useGetLiveEventAISummaryForCustomPromptQuery, useGenerateAIImageMutation } = internalLiveEventPredictionsApi
